<!-- Max Users Reached Screen -->
<ng-container
  *ngIf="showMaxUsersReached"
  [ngTemplateOutlet]="maxUsersReachedTemplate"
></ng-container>

<!-- Community Inactive Screen -->
<ng-container
  *ngIf="showCommunityInactive"
  [ngTemplateOutlet]="communityInactiveTemplate"
></ng-container>

<dx-validation-group
  #registerAccountValidationGroup
  *ngIf="
    !showRegisterDetails &&
    !showSignupAccountName &&
    !showEmailOptions &&
    !showTextOptions &&
    !showMaxUsersReached &&
    !showCommunityInactive
  "
>
  <div class="register-account-form-wrapper">
    <!-- Error Message -->
    <div
      *ngIf="showErrorMessage"
      class="error-message-container"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      <p class="error-message">{{ errorMessage }}</p>
    </div>

    <!-- Info section -->
    <div class="info-section">
      <i class="dx-icon dx-icon-info" (click)="btnShowHelp()"></i>
      <span>Where to locate my account information?</span>
    </div>

    <!-- Account Number Input -->
    <div class="register-input-wrapper">
      <label for="txtAccountNumber" class="input-label">
        Account Number
        <span class="required-asterisk">*</span>
      </label>
      <dx-text-box
        id="txtAccountNumber"
        placeholder="Account Number"
        [(value)]="userInfo.customerID"
        class="account-input"
      >
        <dx-validator>
          <dxi-validation-rule
            type="required"
            message="Account number is required"
          ></dxi-validation-rule>
        </dx-validator>
      </dx-text-box>
    </div>

    <!-- Check Digit Input -->
    <div class="register-input-wrapper">
      <label for="txtCheckDigit" class="input-label">
        Check Digit
        <span class="required-asterisk">*</span>
      </label>
      <dx-text-box
        id="txtCheckDigit"
        placeholder="Check Digit"
        [(value)]="userInfo.checkDigit"
        class="check-digit-input"
      >
        <dx-validator>
          <dxi-validation-rule
            type="required"
            message="Check digit is required"
          ></dxi-validation-rule>
          <dxi-validation-rule
            type="numeric"
            message="Invalid Check digit"
          ></dxi-validation-rule>
        </dx-validator>
      </dx-text-box>
    </div>

    <!-- Back to Sign In Button -->
    <div class="back-to-login-container">
      <dx-button
        #btnBackToSignInRef
        text="Back to Sign In"
        type="default"
        class="back-to-login-button"
        (onClick)="btnBackToSignIn($event)"
      ></dx-button>
    </div>

    <!-- Continue Button -->
    <div class="register-button-wrapper">
      <dx-button
        #btnContinue
        text="Continue"
        type="default"
        class="register-button"
        (onClick)="btnContinueClick($event)"
      ></dx-button>
    </div>

    <!-- Sign In Link -->
    <div class="signin-container">
      <span>Already have an account?</span>
      <a (click)="btnBackToSignIn($event)">Sign in</a>
    </div>
  </div>
</dx-validation-group>

<!-- Signup Account Name Component (User Selection) -->
<div
  *ngIf="
    showSignupAccountName &&
    !showRegisterDetails &&
    !showEmailOptions &&
    !showTextOptions
  "
>
  <app-signup-account-name
    [userInfo]="userInfo"
    [registrationEditor]="registrationEditor"
    (onPreviousClick)="onBackFromSignup()"
    (onPortalAccountUpdate)="onPortalAccountUpdate($event)"
  ></app-signup-account-name>
</div>

<!-- Register Details Component (Email/Password) -->
<div *ngIf="showRegisterDetails && !showEmailOptions && !showTextOptions">
  <app-register-details
    [userInfo]="userInfo"
    [registrationEditor]="registrationEditor"
    [isEmbedded]="isEmbedded"
    (closePanel)="closePanel.emit()"
    (onBack)="onBackFromDetails()"
    (onRegistrationUpdate)="onRegistrationUpdate($event)"
  ></app-register-details>
</div>

<!-- Signup Email Options Component -->
<div *ngIf="showEmailOptions && !showTextOptions">
  <app-signup-email-options
    [userInfo]="userInfo"
    [registrationEditor]="registrationEditor"
    [isEmbedded]="isEmbedded"
    (onPreviousClick)="onBackFromEmailOptions()"
    (onEmailCommunicationUpdate)="onEmailCommunicationUpdate($event)"
    (onBackToLogin)="onCloseRegisterPanel()"
  ></app-signup-email-options>
</div>

<!-- Signup Text Options Component -->
<div *ngIf="showTextOptions">
  <app-signup-text-options
    [userInfo]="userInfo"
    [registrationEditor]="registrationEditor"
    (onPreviousClick)="onBackFromTextOptions()"
    (onBackToLogin)="onCloseRegisterPanel()"
  ></app-signup-text-options>
</div>

<dx-load-panel
  #loadPanel
  shadingColor="rgba(0,0,0,0.4)"
  [(visible)]="loadingVisible"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  [hideOnOutsideClick]="false"
></dx-load-panel>

<cc-message-box #messageBox></cc-message-box>

<dx-popup
  width="75%"
  height="auto"
  [showTitle]="true"
  [showCloseButton]="true"
  title="Where to locate my account information?"
  [dragEnabled]="true"
  [hideOnOutsideClick]="true"
  [(visible)]="isAccountInfoShow"
>
  <div *dxTemplate="let data of 'content'">
    <div dx-scroll-view="{ height: '100%' }" class="container">
      <div class="row help-text-container">
        Your Account Number can be found on your statement as highlighted below.
      </div>
      <div class="row">
        <img [src]="helpImage" class="help-pop-up-image" />
      </div>
    </div>
  </div>
</dx-popup>

<!-- Template: Max Users Reached Screen -->
<ng-template #maxUsersReachedTemplate>
  <div class="account-registered-wrapper">
    <div class="account-registered-content">
      <div class="account-registered-icon">
        <i class="fa-solid fa-user"></i>
        <i class="fa-solid fa-exclamation exclamation-icon"></i>
      </div>

      <p class="account-registered-message mb-7">
        Oops! It looks like this account already has 2 registered users. We do
        not allow more than 2 registered users per account. Please
        <button
          type="button"
          class="link-button signin-link"
          (click)="btnBackToSignIn($event)"
        >
          sign in
        </button>
        with your credentials.
      </p>

      <div class="account-registered-links">
        <div class="link-row">
          <span>
            Forgot your password?
            <button
              type="button"
              class="link-button action-link"
              (click)="btnForgotPassword()"
            >
              Reset now
            </button>
          </span>
        </div>
        <div class="link-row">
          <span>
            Forgot your username or need to validate your email address?
            <button
              type="button"
              class="link-button action-link"
              (click)="btnForgotUsername()"
            >
              Retrieve now
            </button>
          </span>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- Template: Community Inactive Screen -->
<ng-template #communityInactiveTemplate>
  <div class="account-registered-wrapper">
    <div class="account-registered-content">
      <div class="account-registered-icon">
        <i class="fa-solid fa-user"></i>
        <i class="fa-solid fa-exclamation exclamation-icon"></i>
      </div>

      <p class="account-registered-message">
        It looks like your community is no longer active.
      </p>

      <p class="account-registered-submessage">
        Please reach out to your community manager for help.
      </p>
    </div>
  </div>
</ng-template>
